// utils/getValueByPath.js
export const getValueByPath = (obj, path) =>
    path.split('.').reduce((acc, part) => {
      const match = part.match(/(\w+)\[(\d+)\]/);
      if (match) {
        const [, key, index] = match;
        return acc?.[key]?.[parseInt(index)];
      }
      return acc?.[part];
    }, obj);
  